import React from 'react';

export const NotFound: React.FC = () => <div>Not Found</div>;
